/**
 * 通用弹窗组件
 */
import React from 'react';
import './Modal.css';

const Modal = ({ 
  visible, 
  title, 
  subtitle,
  children, 
  onClose, 
  footer,
  className = ''
}) => {
  if (!visible) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal ${className}`} onClick={e => e.stopPropagation()}>
        {(title || subtitle) && (
          <div className="modal-header">
            {title && <h2 className="modal-title">{title}</h2>}
            {subtitle && <p className="modal-subtitle">{subtitle}</p>}
          </div>
        )}
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
};

export default Modal;
